/**
 * Approvals — `docs/API.md` §7. Entity-agnostic on the server; quotations are
 * the only thing that opens a request today. Mirrors
 * `salescrmapi/src/modules/approvals`.
 */
import apiClient from './axiosClient.js';

/** @param {object} [params] `{ status, entity_key, overdue, assigned_to }` */
export async function listApprovals(params = {}) {
  const { data } = await apiClient.get('/approvals', { params });
  return data;
}

/** @param {string} requestId @param {{decision:'approved'|'rejected', note?:string}} payload */
export async function decideApproval(requestId, payload) {
  const { data } = await apiClient.post(`/approvals/${requestId}/decide`, payload);
  return data;
}
